module.exports = __webpack_public_path__ + "img/hatate himekaidou_sc2.c0e84f7f.png";